import $ from 'jquery';

window.copyLink = function(el) {
    var input = $(el).parents('.uk-modal-body').find('input')[0];
    input.select();
    document.execCommand("copy");
}


// WEBPACK FOOTER //
// ./resources/components/tour-type/tour-type_custom/tour-type_custom.js